import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutComponent } from './pages/company/about/about.component';
import { CareersComponent } from './pages/company/careers/careers.component';
import { TeamComponent } from './pages/company/team/team.component';
import { ContactComponent } from './pages/contact/contact.component';
import { ClientsServicesComponent } from './pages/e-services/clients-services/clients-services.component';
import { ContractorComponent } from './pages/e-services/contractor/contractor.component';
import { EmployeeServicesComponent } from './pages/e-services/employee-services/employee-services.component';
import { HomeComponent } from './pages/home/home.component';
import { QuoteComponent } from './pages/quote/quote.component';
import { ArticlesComponent } from './pages/articles/articles.component';
import { ArticleDetailsComponent } from './pages/article-details/article-details.component';

const routes: Routes = [
  {
    path: 'Home',
    component: HomeComponent,
    data: {
      title: 'Home',
      breadcrumb: 'Home'
    }
  },
  {
    path: 'Quote',
    component: QuoteComponent,
    data: {
      title: 'Quote',
      breadcrumb: 'Quote'
    }
  },
  {
    path: 'Contact',
    component: ContactComponent,
    data: {
      title: 'Contact',
      breadcrumb: 'Contact'
    }
  },
  {
    path: 'About',
    component: AboutComponent,
    data: {
      title: 'About',
      breadcrumb: 'About',
    }
  },
  {
    path: 'Careers',
    component: CareersComponent,
    data: {
      title: 'Career',
      breadcrumb: 'Career'
    }
  },
  // {
  //   path: 'Team',
  //   component: TeamComponent,
  //   data: {
  //     title: 'Team',
  //     breadcrumb: 'Team'
  //   }
  // },
  {
    path: 'Clients-services',
    component: ClientsServicesComponent,
    data: {
      title: 'Clients-services',
      breadcrumb: 'Clients-services'
    }
  },
  {
    path: 'Articles',
    component: ArticlesComponent,
    data: {
      title: 'Articles',
      breadcrumb: 'Articles'
    }
  },
  {
    path: 'Articles/:slug',
    component: ArticleDetailsComponent,
    data: {
      title: 'Article Details',
      breadcrumb: 'Article Details'
    }
  },
  {
    path: 'Contractor',
    component: ContractorComponent,
    data: {
      title: 'Contractor',
      breadcrumb: 'Contractor'
    }
  },
  {
    path: 'Employee-services',
    component: EmployeeServicesComponent,
    data: {
      title: 'Employee-services',
      breadcrumb: 'Employee-services'
    }
  },
  { path: '', redirectTo: '/Home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
